import React, { useState, useEffect, useRef } from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import Config from "../Config";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import Loading from "react-loading";
import {
  Save_User,
  Save_Property,
  Select_Property,
  Save_Partners,
  Select_Partner,
} from "../Redux/actions";
import { useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { hasPermission, PERMISSION_ROUTE_MAP } from "../helpers";
import {
  SubmitBtn,
  InputGroup,
  FieldWrapper,
  Label,
} from "../Components/Styles/InputStyles";
import { useTranslation } from "react-i18next";

const LoginRight = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showBrokerForm, setShowBrokerForm] = useState(false);
  const [verifiedPhone, setVerifiedPhone] = useState("");
  const firstOtpRef = useRef(null);

  const InitialValue = {
    phone: "",
    otp: ["", "", "", "", "", ""],
    brokerName: "",
    email: "",
    city: "",
    // firmName: ""
  };

  useEffect(() => {
    if (showOtpInput && firstOtpRef.current) {
      firstOtpRef.current.focus();
    }
  }, [showOtpInput]);

  //------- Send OTP Request (Commented) -------
  const requestOtp = async (phone) => {
    return await axios.post(
      `${Config.apiUrl}/auth/login`,
      {
        mobile: phone,
        platform: 3,
      },
      null,
    );
  };

  const onSuccess = (res) => {

    if (res?.data?.success === true) {
      setShowOtpInput(true);
    }
  };

  const onError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingOtp, mutate: postOtpRequest } = useMutation(
    requestOtp,
    {
      onSuccess: onSuccess,
      onError: onError,
    },
  );

  //------- Verify OTP Request (Commented) -------
  const verifyOtp = async (values) => {
    const body = new FormData();
    body.append("mobile", values.phone);
    body.append("otp", values.otp.join(""));
    return await axios.post(
      `${Config.apiUrl}/auth/verify`,
      {
        mobile: values.phone,
        otp: values.otp.join(""),
      },
      null,
    );
  };

  const onVerifySuccess = (res, values) => {

    // const hardcodedProperties = [
    //   {
    //     id: 0,
    //     name: "All Properties",
    //     gId: "KIPINN",
    //     type: 0,
    //     tenantPreference: 3,
    //     tenantCount: 147,
    //     bedCount: 471,
    //     occupiedBedCount: 184,
    //     vacantBedCount: 287
    //   },
    //   {
    //     id: 796,
    //     name: "01sept",
    //     type: 1,
    //     gId: "KIPN11982",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 3,
    //     bedCount: 3,
    //     occupiedBedCount: 2,
    //     tenantCount: 2,
    //     vacantBedCount: 1,
    //     flats: []
    //   },
    //   {
    //     id: 799,
    //     name: "05Sept",
    //     type: 1,
    //     gId: "KIPN10472",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 5,
    //     bedCount: 5,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 5,
    //     flats: []
    //   },
    //   {
    //     id: 715,
    //     name: "12july",
    //     type: 1,
    //     gId: "KIPN11672",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 7,
    //     bedCount: 7,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 7,
    //     flats: []
    //   },
    //   {
    //     id: 559,
    //     name: "13 April",
    //     type: 2,
    //     gId: "KIPN10335",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 0,
    //     bedCount: 0,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 0,
    //     flats: []
    //   },
    //   {
    //     id: 727,
    //     name: "17 july",
    //     type: 1,
    //     gId: "KIPN11428",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 0,
    //     bedCount: 0,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 0,
    //     flats: []
    //   },
    //   {
    //     id: 729,
    //     name: "17 july.",
    //     type: 1,
    //     gId: "KIPN11541",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 0,
    //     bedCount: 0,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 0,
    //     flats: []
    //   },
    //   {
    //     id: 774,
    //     name: "18 aug",
    //     type: 1,
    //     gId: "KIPN10415",
    //     tenantPreference: 3,
    //     locationId: 200,
    //     locationName: "Faridabad, Haryana",
    //     roomCount: 0,
    //     bedCount: 0,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 0,
    //     flats: []
    //   },
    //   {
    //     id: 733,
    //     name: "18july",
    //     type: 1,
    //     gId: "KIPN10308",
    //     tenantPreference: 3,
    //     locationId: 216,
    //     locationName: "Panipat, Haryana",
    //     roomCount: 0,
    //     bedCount: 0,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 0,
    //     flats: []
    //   },
    //   {
    //     id: 618,
    //     name: "1ggfh",
    //     type: 2,
    //     gId: "KIPN11825",
    //     tenantPreference: 3,
    //     locationId: 21,
    //     locationName: "New Delhi, Delhi",
    //     roomCount: 25,
    //     bedCount: 25,
    //     occupiedBedCount: 0,
    //     tenantCount: 0,
    //     vacantBedCount: 25,
    //     flats: []
    //   }
    // ];
    // const hardcodedPartner = [
    //   {
    //     clientId: 110,
    //     parentId: null,
    //     clientName: "Build",
    //     propertyCount: 48,
    //     totalBeds: 471,
    //     tenantCount: 148,
    //     totalOccupiedBeds: 184
    //   },
    //   {
    //     clientId: 644,
    //     parentId: 110,
    //     clientName: "Jaglan",
    //     propertyCount: 1,
    //     totalBeds: 1,
    //     tenantCount: 0,
    //     totalOccupiedBeds: 0
    //   },
    //   {
    //     clientId: 708,
    //     parentId: 110,
    //     clientName: "aadu",
    //     propertyCount: 1,
    //     totalBeds: 3,
    //     tenantCount: 0,
    //     totalOccupiedBeds: 0
    //   },
    //   {
    //     clientId: 721,
    //     parentId: 110,
    //     clientName: "New Partner",
    //     propertyCount: 2,
    //     totalBeds: 8,
    //     tenantCount: 0,
    //     totalOccupiedBeds: 0
    //   },
    //   {
    //     clientId: 723,
    //     parentId: 110,
    //     clientName: "partner",
    //     propertyCount: 1,
    //     totalBeds: 3,
    //     tenantCount: 0,
    //     totalOccupiedBeds: 0
    //   }
    // ];
    // const allPropertiesData = {
    //   id: 0,
    //   name: "All Properties",
    //   gId: "KIPINN",
    //   type: 0,
    //   tenantPreference: 3,
    //   tenantCount: 147,
    //   bedCount: 471,
    //   occupiedBedCount: 184,
    //   vacantBedCount: 287
    // };

    // const hardcodedUserData = {
    //   id: 110,
    //   parentId: null,
    //   name: "Build",
    //   mobile: "0000000025",
    //   propertyCount: 1,
    //   acquiredBy: "self",
    //   businessAddress: null,
    //   businessEmail: null,
    //   businessName: null,
    //   canDoStaffEkyc: 0,
    //   canDoTenantEkyc: 0,
    //   canFullyOccupied: 0,
    //   canPayLandlord: 0,
    //   canSendRentReminderToAll: 0,
    //   canTenantRequestRoom: 1,
    //   city: "Bangalore, Karnataka",
    //   createdAt: "2024-10-22 10:50:09",
    //   creditCardCharges: "2.25",
    //   creditCardEnabled: 0,
    //   defaultTenantFilter: "",
    //   device: 3,
    //   expireAt: 1771250251505,
    //   gstNo: null,
    //   holdOutBalance: null,
    //   isBankDetailsShown: 0,
    //   lastLogin: "2026-02-16 18:11:16",
    //   logo: null,
    //   netBankingEnabled: 0,
    //   otherCharges: "2.25",
    //   ownershipPercentage: 100,
    //   panNumber: "BGLPS5973C",
    //   paymentGateway: 1,
    //   paymentLinkBaseUrl: null,
    //   payuHoldKey: null,
    //   payuHoldMid: null,
    //   payuKey: null,
    //   payuMid: null,
    //   regId: "e4wP0eFLSIOlrqr4hhqL9Z:APA91bHUhl6vaLVSkx_SFPPcbptSAEqFDuSaTt9AVa3ltYoPtmvncEiotyReOgAKOLO6-uv0XEIMFqZz-P3FqTosHVROcbYPsoeoF49N1z6MkUKIWyO1vhg",
    //   status: 4,
    //   systemAlerts: 0,
    //   tenantAttendanceEnabled: 1,
    //   token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTEwLCJ0eXBlIjoxLCJwbGF0Zm9ybSI6MywiaWF0IjoxNzcxMjQ2NjUzLCJleHAiOjE3NzkwMjI2NTN9.H650rM0hbvwf4INh8W282XpMmYaXt8wBN8WtNx3Vo4w",
    //   updatedAt: "2026-02-16 18:11:16",
    //   upiCharges: "0.00",
    //   upiEnabled: 1,
    //   userRole: 0,
    //   userType: 1,
    //   website: null,
    //   brokerDetails: "yes",
    // };
    if (res?.data?.success === true) {
      const expireAt = moment()
        .add(Config.sessionExpiredTime, "minutes")
        .valueOf();
      const token = res.data.token;

      const realData = {
        ...res.data.user,
        token,
        expireAt,
        // permissions: res.data.user.permissions || 0,
      };
      if (res?.data?.isNewUser === true) {
        setShowBrokerForm(true);
        setShowOtpInput(false);
        setVerifiedPhone(values.phone);
      } else {
        dispatch(Save_User(realData));
        navigate("/dashboard");
      }
      // propertyListing(token).then((propertyRes) => {
      //   if (propertyRes) {
      //     const properties = propertyRes?.data?.data || [];

      //     const totalTenantCount = properties.reduce(
      //       (total, prop) => total + (prop.tenantCount || 0),
      //       0,
      //     );
      //     const totalOccupiedBedCount = properties.reduce(
      //       (total, prop) => total + (prop.occupiedBedCount || 0),
      //       0,
      //     );
      //     const totalBedCount = properties.reduce(
      //       (total, prop) => total + (prop.bedCount || 0),
      //       0,
      //     );

      //     const allProperty = {
      //       id: 0,
      //       name: "All Properties",
      //       gId: "KIPINN",
      //       type: 0,
      //       tenantPreference: 3,
      //       tenantCount: totalTenantCount,
      //       occupiedBedCount: totalOccupiedBedCount,
      //       bedCount: totalBedCount,
      //     };
      //     const propertiesWithAll = [allProperty, ...properties];

      //     if (res.data.user.userType === 1) {
      //       dispatch(Save_Partners(res?.data?.personalAndPartnerProperties));
      //       dispatch(
      //         Select_Partner(res?.data?.personalAndPartnerProperties[0]),
      //       );
      //     }
      //     dispatch(Save_Property(propertiesWithAll));
      //     dispatch(Select_Property(allProperty));
      //     dispatch(Save_User(realData));

      //     if (
      //       res.data.user.userType === 1 ||
      //       res.data.user.role === Config.STAFF_ROLES.ADMIN ||
      //       res.data.user.role === Config.STAFF_ROLES.PARTNER ||
      //       res.data.user.role === Config.STAFF_ROLES.FINANCEADMIN
      //     ) {
      //       navigate("/dashboard");
      //     } else if (res.data.user.userType === Config.USER_TYPE.LANDLORD) {
      //       navigate("/landlord/dashboard");
      //     } else {
      //       let finalRoute = "/property-list"; // default
      //       for (const item of PERMISSION_ROUTE_MAP) {
      //         if (hasPermission(item.permission, res.data.user)) {
      //           finalRoute = item.route;
      //           break;
      //         }
      //       }
      //       navigate(finalRoute);
      //     }
      //   }
      // });

      // For frontend demo, show broker form instead
      // if (hardcodedUserData.userType === 1) {
      //   dispatch(Save_Partners(hardcodedPartner));
      //   dispatch(Select_Partner(hardcodedPartner[0]));
      // }
      // dispatch(Save_Property(hardcodedProperties));
      // dispatch(Select_Property(allPropertiesData));
      // dispatch(Save_User(hardcodedUserData));

      // setVerifiedPhone(values.phone);

      // if (hardcodedUserData?.brokerDetails === "yes") {
      //   navigate("/dashboard");
      // } else {
      //   setShowBrokerForm(true);
      //   setShowOtpInput(false);
      // }
    }
  };





  const onVerifyError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingVerify, mutate: postVerifyOtp } = useMutation(
    verifyOtp,
    {
      onSuccess: onVerifySuccess,
      onError: onVerifyError,
    },
  );

  //------- Broker Request (Commented) -------
  const brokerForm = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/auth/register`,
      {
        mobile: values.phone,
        name: values.brokerName,
        email: values.email,
        city: values.city,
        // businessName: values.firmName,
        platform: 3,
      },
      null,
    );
  };

  const onFormSuccess = (res) => {

    if (res?.data?.success === true) {
      const expireAt = moment()
        .add(Config.sessionExpiredTime, "minutes")
        .valueOf();
      const token = res.data.token;

      const realData = {
        ...res.data.user,
        token,
        expireAt,
        // permissions: res.data.user.permissions || 0,
      };
      dispatch(Save_User(realData));
      navigate("/dashboard");
      setShowOtpInput(true);
    }
  };

  const onFormError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingForm, mutate: postFormRequest } = useMutation(
    brokerForm,
    {
      onSuccess: onFormSuccess,
      onError: onFormError,
    },
  );


  // Mock loading states
  // const [isLoadingOtp, setIsLoadingOtp] = useState(false);
  // const [isLoadingVerify, setIsLoadingVerify] = useState(false);

  const handleGetOtp = (phone) => {
    if (!phone) {
      return toast.error("Please enter a valid 10-digit mobile number.");
    }
    if (phone.length !== 10) {
      return toast.error("Please enter a valid 10-digit mobile number.");
    }

    // Mock API call
    // setIsLoadingOtp(true);
    // setTimeout(() => {
    //   setIsLoadingOtp(false);
    //   setShowOtpInput(true);
    //   toast.success("OTP sent successfully!");
    // }, 1000);

    postOtpRequest(phone);
  };

  const handleVerifyOtp = (values) => {
    if (values.otp.some((digit) => !digit)) {
      return toast.error("Please enter complete OTP");
    }

    // Mock API call
    // setIsLoadingVerify(true);
    // setTimeout(() => {
    //   setIsLoadingVerify(false);
    //   onVerifySuccess(null, values);
    //   toast.success("OTP verified successfully!");
    // }, 1000);

    postVerifyOtp(values);
  };

  const handleBrokerSubmit = (values) => {
    // Validate broker form
    if (!values.brokerName) {
      return toast.error("Please your name");
    }
    if (values.email && values.email.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      if (!emailRegex.test(values.email)) {
        return toast.error("Please enter a valid email address");
      }
    }
    if (!values.city) {
      return toast.error("Please entr your city/location");
    }
    postFormRequest(values)
    // Mock submission
    // toast.success("Broker information saved successfully!");
    // navigate("/dashboard");

    // Here you can handle the final submission
    // You might want to redirect or show success message
  };

  return (
    <Logins>
      <TextWrapperComp
        InitialValue={InitialValue}
        handleGetOtp={handleGetOtp}
        handleVerifyOtp={handleVerifyOtp}
        handleBrokerSubmit={handleBrokerSubmit}
        isLoadingOtp={isLoadingOtp}
        isLoadingVerify={isLoadingVerify}
        showOtpInput={showOtpInput}
        showBrokerForm={showBrokerForm}
        setShowOtpInput={setShowOtpInput}
        verifiedPhone={verifiedPhone}
        t={t}
        firstOtpRef={firstOtpRef}
      />
      <FooterSection>
        <img
          src={Images.FooterBg}
          alt="footer"
          className="w-full h-auto opacity-50"
        />
      </FooterSection>
    </Logins>
  );
};

const TextWrapperComp = ({
  InitialValue,
  handleGetOtp,
  handleVerifyOtp,
  handleBrokerSubmit,
  isLoadingOtp,
  isLoadingVerify,
  showOtpInput,
  showBrokerForm,
  setShowOtpInput,
  verifiedPhone,
  t,
  firstOtpRef,
}) => {
  const navigate = useNavigate();

  return (
    <TextWrapper>
      <Container>
        <div>
          <Center>
            <div className="flex space-x-6">
              <Logo src={Images.Login_Logo} alt="logo" />
            </div>
            <Title>
              {showBrokerForm
                ? "Set Up Your Profile"
                : "Please Login with your Mobile Number"}
            </Title>
            <Formik
              initialValues={InitialValue}
              onSubmit={(values) => {
                if (showBrokerForm) {
                  handleBrokerSubmit(values);
                } else if (showOtpInput) {
                  handleVerifyOtp(values);
                } else {
                  handleGetOtp(values.phone);
                }
              }}
            >
              {({ values, setFieldValue }) => (
                <Form className="w-full">
                  <FormContainer>
                    {!showBrokerForm ? (

                      <>
                        <InputGroup>
                          <Label htmlFor="phone">{"Mobile Number"}</Label>
                          <FieldWrapper>
                            <Field
                              name="phone"
                              id="phone"
                              type="text"
                              inputMode="numeric"
                              maxLength={10}
                              autoComplete="off"
                              disabled={showBrokerForm}
                              onChange={(e) => {
                                const newValue = e.target.value.replace(/[^0-9]/g, "");
                                setFieldValue("phone", newValue);

                                if (showOtpInput) {
                                  setShowOtpInput(false);
                                  setFieldValue("otp", ["", "", "", "", "", ""]);
                                }
                              }}
                            />
                          </FieldWrapper>
                          {showOtpInput && (
                            <div className="flex justify-end items-center max-w-sm space-x-2">
                              <div className="text-gray-500 text-xs md:text-sm lg:text-md">
                                Did not receive an OTP?
                              </div>
                              <button
                                type="button"
                                onClick={() => handleGetOtp(values.phone)}
                                className="text-teal-600 font-medium text-xs md:text-sm lg:text-md"
                                disabled={isLoadingOtp}
                              >
                                Resend OTP
                              </button>
                            </div>
                          )}
                        </InputGroup>

                        {showOtpInput && (
                          <InputGroup>
                            <Label htmlFor="otp">{"Enter OTP"}</Label>
                            <div className="flex space-x-2">
                              {[0, 1, 2, 3, 4, 5].map((index) => (
                                <input
                                  key={index}
                                  ref={index === 0 ? firstOtpRef : null}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  className="w-10 h-10 text-center border rounded"
                                  value={values.otp[index]}
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /[^0-9]/g,
                                      "",
                                    );
                                    if (inputValue.length > 1) return;
                                    const newOtp = [...values.otp];
                                    newOtp[index] = inputValue;
                                    setFieldValue("otp", newOtp);
                                    if (e.target.value && index < 5) {
                                      document
                                        .getElementById(`otp-${index + 1}`)
                                        .focus();
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" &&
                                      !values.otp[index] &&
                                      index > 0
                                    ) {
                                      document
                                        .getElementById(`otp-${index - 1}`)
                                        .focus();
                                    } else if (e.key === "ArrowLeft" && index > 0) {
                                      document
                                        .getElementById(`otp-${index - 1}`)
                                        .focus();
                                    } else if (e.key === "ArrowRight" && index < 5) {
                                      document
                                        .getElementById(`otp-${index + 1}`)
                                        .focus();
                                    }
                                  }}
                                  id={`otp-${index}`}
                                />
                              ))}
                            </div>
                          </InputGroup>
                        )}
                      </>
                    ) : (
                      // Broker Information Form
                      <>
                        <InputGroup>
                          <Label htmlFor="brokerName">{"Your Name *"}</Label>
                          <FieldWrapper>
                            <Field
                              name="brokerName"
                              id="brokerName"
                              type="text"
                              placeholder="Enter your name"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="email">{"Email"}</Label>
                          <FieldWrapper>
                            <Field
                              name="email"
                              id="email"
                              type="email"
                              placeholder="Enter email address"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="city">{"City *"}</Label>
                          <FieldWrapper>
                            <Field
                              name="city"
                              id="city"
                              type="text"
                              placeholder="Enter city"
                              autoComplete="off"
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^a-zA-Z\s-]/g, "");
                              }}
                            />
                          </FieldWrapper>
                        </InputGroup>

                        {/* <InputGroup>
                      <Label htmlFor="firmName">{"Firm Name *"}</Label>
                      <FieldWrapper>
                        <Field
                          name="firmName"
                          id="firmName"
                          type="text"
                          placeholder="Enter firm name"
                          autoComplete="off"
                        />
                      </FieldWrapper>
                    </InputGroup> */}

                      </>
                    )}
                  </FormContainer>
                  <div className="mt-4 lg:mt-10 flex">
                    <SubmitBtn
                      type="submit"
                      disabled={isLoadingOtp || isLoadingVerify}
                    >
                      {isLoadingOtp || isLoadingVerify ? (
                        <Loading color="white" width={20} height={20} />
                      ) : showBrokerForm ? (
                        "Continue"
                      ) : showOtpInput ? (
                        "Verify OTP"
                      ) : (
                        "Get OTP"
                      )}
                    </SubmitBtn>
                  </div>
                </Form>
              )}
            </Formik>
          </Center>
        </div>
        {!showBrokerForm && (
          <div className="pb-6">
            <p className="text-xs text-gray-500 text-center max-w-full mx-auto leading-relaxed">
              By continuing, you agree to our{" "}
              <a
                href="https://kipinn.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline whitespace-nowrap text-[#26A69A] font-medium hover:underline"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://kipinn.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline whitespace-nowrap text-[#26A69A] font-medium hover:underline"
              >
                Privacy Policy
              </a>.
            </p>
          </div>
        )}

        {!showBrokerForm && (
        <div className="absolute bottom-5 -right-12 text-right text-xs text-gray-500">
          Want to generate a salary slip?{" "}
          <button
            type="button"
            onClick={() => navigate("/free-payslip-generator")}
            className="font-medium text-[#26A69A] hover:underline text-[13px]"
          >
            Generate Payslip
          </button>
        </div>
      )}

      </Container>

    </TextWrapper>
  );
};

const FormContainer = tw.div`grid max-w-sm mt-4 w-full gap-3 md:gap-2`;
const Logins = tw.section`h-dvh flex bg-white justify-center items-center px-6 sm:px-10 md:px-12 lg:px-16 xl:px-20`;
const Container = tw.div`flex flex-col h-full w-full justify-center items-start px-4 sm:px-6 md:px-8 lg:px-10`;
const Logo = tw.img`w-20 h-20 object-contain mb-10 sm:w-24 sm:h-24 md:w-28 md:h-28`;
const TextWrapper = tw.div`h-full relative sm:max-w-sm sm:text-lg md:w-full md:max-w-md md:text-xl lg:max-w-lg lg:text-base xl:max-w-xl xl:text-lg`;
const Title = tw.h1`text-lg font-light text-gray-800 tracking-wider md:text-xl`;
const Center = tw.div`h-full w-full flex flex-col justify-center py-8 sm:py-10 md:py-12`;
const FooterSection = tw.div`lg:hidden md:block sm:block absolute bottom-0 left-0 w-full h-6`;

export default LoginRight;









